import { useApiGet } from '@sierralabs/core-ui';
export function useSearchFiles() {
    return useApiGet('files/search');
}
//# sourceMappingURL=useSearchFiles.js.map